import styled, { keyframes } from 'styled-components'

export const bounceAnimation = keyframes`
  0%, 80%, 100% {
    transform: translateY(0); 
  }
  40% {
    transform: translateY(-10px); 
  }
`

export const Ball = styled.div`
  width: 10px;
  height: 10px;
  background: #8e489c;
  border-radius: 50%;
  margin: 0 5px;
  animation: ${bounceAnimation} 1s infinite ease-in-out;
  &:nth-child(2) {
    animation-delay: 0.1s;
  }
  &:nth-child(3) {
    animation-delay: 0.2s;
  }
`

export const LoadingContainer = styled.div`
  background-color: #e0e0e0;
  padding: 15px;
  border-radius: 10px 10px 10px 0px;
  margin: 0;

  display: flex;
  justify-content: center;
`
